module.exports = __webpack_public_path__ + "static/media/general-brightness.cbaf7622.png";